import React from 'react';
import styled from 'styled-components';

const FlexBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
`;

export default FlexBox;
